/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

document.addEventListener('DOMContentLoaded', function() {
  const drawerEl = document.getElementById('MobileDrawer');
  const openBtn  = document.querySelector('.js-open-mobile-drawer');
  const closeBtn = document.querySelector('.mobile-drawer__close');
  

  console.log('Drawer:', drawerEl, 'Open Btn:', openBtn, 'Close Btn:', closeBtn);

  if (drawerEl && openBtn && closeBtn) {
    openBtn.addEventListener('click', () => {
      console.log('Opening drawer');
      drawerEl.classList.add('is-open');
    });
    closeBtn.addEventListener('click', () => {
      console.log('Closing drawer');
      drawerEl.classList.remove('is-open');
    });
  }
});


  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
